import { Border, Margin, Padding } from 'componentregistry';

// eslint-disable-next-line import/prefer-default-export
export function getWidthHeight(
  height?: number,
  width?: number,
  padding?: Padding,
  border?: Border,
  margin?: Margin,
) {
  let outerWidth = width;
  let outerHeight = height;
  let innerLeft = 0;
  let innerTop = 0;
  if (margin) {
    const { all } = margin;
    let { top, bottom, left, right } = margin;
    if (all !== undefined) {
      left = all;
      bottom = all;
      top = all;
      right = all;
    }
    if (outerWidth) {
      innerLeft += left ?? 0;
      outerWidth -= (left ?? 0) + (right ?? 0);
    }
    if (outerHeight) {
      innerTop += top ?? 0;
      outerHeight -= (top ?? 0) + (bottom ?? 0);
    }
  }

  let innerWidth = outerWidth;
  let innerHeight = outerHeight;
  if (padding) {
    const { all } = padding;
    let { top, bottom, left, right } = padding;
    if (all !== undefined) {
      left = all;
      bottom = all;
      top = all;
      right = all;
    }
    if (innerWidth) {
      innerLeft += left ?? 0;
      innerWidth -= (left ?? 0) + (right ?? 0);
    }
    if (innerHeight) {
      innerTop += top ?? 0;
      innerHeight -= (top ?? 0) + (bottom ?? 0);
    }
  }

  if (border) {
    const { all } = border;
    let { top, bottom, left, right } = border;
    if (all !== undefined) {
      left = all;
      bottom = all;
      top = all;
      right = all;
    }
    if (innerWidth) {
      // innerLeft += left?.width ?? 0;
      innerWidth -= (left?.width ?? 0) + (right?.width ?? 0);
    }
    if (innerHeight) {
      // innerTop += top?.width ?? 0;
      innerHeight -= (top?.width ?? 0) + (bottom?.width ?? 0);
    }
  }
  return {
    outerHeight,
    outerWidth,
    innerHeight,
    innerWidth,
    innerLeft,
    innerTop,
  };
}
